import { render } from "./AgreementLoader.vue?vue&type=template&id=def55d92"
import script from "./AgreementLoader.vue?vue&type=script&lang=js"
export * from "./AgreementLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__